import BaseComponent from '../../../general/js/base-component';
import HtmlHelper from "../../../general/js/html-helper";
import {BUYING_FOR_SOMEONE_ELSE} from './buying-for-options'

export default class BuyerFormComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        this.buyerStatusSection = this.refs.buyerStatusSection;
        this.buyerStatusInput = this.refs.buyerStatusInput;

        this.privatIndividualValue = this.buyerStatusInput.getAttribute('data-private-individual-value');
        if (!this.privatIndividualValue) {
            throw new Error('data-private-individual-value should be defined');
        }

        this.directorshipConfirmedSection = this.refs.directorshipConfirmed;

        this.buyingFor = null;
        this.registerByTelephone = false;

        this.onBuyerStatusChange = this.onBuyerStatusChange.bind(this);
        this.init();
    }

    static getRequiredRefs() {
        return ['buyerStatusSection', 'buyerStatusInput', 'directorshipConfirmed'];
    }

    init() {
        this.buyerStatusInput.addEventListener('change', this.onBuyerStatusChange);
        this.updateDirectorshipConfirmedVisibility();
    }

    onBuyerStatusChange(e) {
        this.updateDirectorshipConfirmedVisibility();
    }

    setBuyingFor(value) {
        this.buyingFor = value;

        if (this.buyingFor !== BUYING_FOR_SOMEONE_ELSE) {
            HtmlHelper.showFormHiddenGroup(this.buyerStatusSection);
        } else {
            HtmlHelper.hideFormHiddenGroup(this.buyerStatusSection);
            HtmlHelper.resetFormSection(this.buyerStatusSection);
        }

        this.updateDirectorshipConfirmedVisibility();
    }

    setRegisterByTelephone(value) {
        this.registerByTelephone = value;
        this.updateDirectorshipConfirmedVisibility();
    }

    updateDirectorshipConfirmedVisibility() {
        if (this.buyingFor !== BUYING_FOR_SOMEONE_ELSE && this.registerByTelephone && this.buyerStatusInput.value && this.buyerStatusInput.value !== this.privatIndividualValue) {
            HtmlHelper.showFormHiddenGroup(this.directorshipConfirmedSection);
        } else {
            HtmlHelper.hideFormHiddenGroup(this.directorshipConfirmedSection);
            HtmlHelper.resetFormSection(this.directorshipConfirmedSection);
        }
    }

    onDestroy() {
        this.buyerStatusInput.removeEventListener('change', this.onBuyerStatusChange);
    }
}




// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/buyer-form.component.js